import {Fragment} from "react";
import AddCustomFieldContent from "./AddCustomFieldContent";
import useFetchCustomFieldsFromSourcePlatform from "./hooks/useFetchCustomFieldsFromSourcePlatform";

export default function AddCustomFieldContainer({msgDataSourceId, handleClose}) {

    const {customFields, fetchCustomFieldsLoading} = useFetchCustomFieldsFromSourcePlatform(msgDataSourceId);

    return (
        <Fragment>
            <AddCustomFieldContent
                handleClose={handleClose}
                msgDataSourceId={msgDataSourceId}
                customFields={customFields}
                fetchCustomFieldsLoading={fetchCustomFieldsLoading}
            />
        </Fragment>
    )
}